document.addEventListener("DOMContentLoaded", () => {
  const filterButtons = document.querySelectorAll(
    ".sp-hair-filter__filter .filter-button"
  );
  const productGrid = document.querySelector(".sp-hair-filter__filter-items");
  const productCards = productGrid.querySelectorAll(".product-card");

  const updateGridClass = () => {
    const visibleCards = Array.from(productCards).filter(
      (card) => card.style.display === "block"
    );

    if (visibleCards.length < 4) {
      productGrid.classList.add("small-grid");
    } else {
      productGrid.classList.remove("small-grid");
    }
  };

  const filterProducts = (button) => {
    const isShowAll = button.classList.contains("show-all");
    const activeCollection = button.getAttribute("data-url");

    productCards.forEach((card) => {
      if (isShowAll) {
        card.style.display = "block";
      } else {
        const collections =
          card.getAttribute("data-collections")?.split(",") || [];
        if (collections.includes(activeCollection)) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      }
    });
    updateGridClass();
  };

  const activeButton = Array.from(filterButtons).find((button) =>
    button.classList.contains("active")
  );
  if (activeButton) {
    filterProducts(activeButton);
  }

  filterButtons.forEach((button) => {
    button.addEventListener("click", () => {
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      filterProducts(button);
    });
  });
});
